import { DataTableSortOrderType } from "primereact/datatable";

// API base URLs (switch as needed)
// export const baseUrl: string = "https://api.jobvritta.com/api/";
// export const baseUrl: string = "https://api.stage.jobvritta.com/api/";
// export const baseUrl: string = "https://localhost:62225/api/";
export const baseUrl: string = "https://stg-jungleave-back.jobvritta.com/api/";
//export const baseUrl: string = "https://jungleavengers-api.jobvritta.com/api/";
//export const baseUrl: string = "https://stg-jungleave-back.jobvritta.com/api/";
// export const baseUrl: string = "https://admintestapi.jobvritta.com/api/";
//export const baseUrl: string = "https://auditapi.jobvritta.com/api/";
// export const baseUrl: string = "https://portal.jobvritta.com/api/";
// export const baseUrl: string = "https://adminapi.jobvritta.com/api/";

export interface ILazyParams {
    first: number;
    rows: number;
    page: number;
    sortField: string;
    sortOrder: DataTableSortOrderType;
}

export const Fetch = async (
    url: string,
    method: "GET" | "POST" | "PUT" | "DELETE",
    body: any,
    query: string | null,
    toast: any
) => {
    let params: RequestInit = {
        method: method,
        headers: {
            'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
        }
    };

    if (body) {
        if (body instanceof FormData) {
            // ✅ Let the browser set Content-Type & boundary
            params.body = body;
        } else {
            // ✅ JSON request
            params.headers = {
                ...params.headers,
                'Content-Type': 'application/json'
            };
            params.body = JSON.stringify(body);
        }
    }

    const queryString = query ? `?${query}` : "";

    try {
        const response = await fetch(`${baseUrl}${url}${queryString}`, params);

        if (response.status === 401) {
            sessionStorage.clear();
            toast?.current?.show({
                severity: 'error',
                detail: "Unauthorized. Please Login!",
                life: 3000
            });
            window.location.href = '/login';
            return undefined;
        } else if (!response.ok) {
            let message = "";
            try {
                const text = await response.text();
                try {
                    const res = JSON.parse(text);
                    message = res.error ?? res.message ?? (typeof res === 'string' ? res : "");
                } catch {
                    message = text;
                }
            } catch {
                message = "";
            }

            toast?.current?.show({
                severity: 'error',
                detail: message || (response.status === 400 ? "Bad request" : "Something went wrong!"),
                life: 3000
            });
            return undefined;
        }
        return response;
    } catch {
        toast?.current?.show({
            severity: 'error',
            detail: 'There has been some network trouble or server is not responding.',
            life: 3000
        });
        return undefined;
    }
};
